export const mapStyles = [
	{
		featureType: 'all',
		elementType: 'geometry',
		stylers: [{ color: '#798da1' }],
	},
	{
		featureType: 'all',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#5c3f35' }],
	},
	{
		featureType: 'all',
		elementType: 'labels.text.stroke',
		stylers: [{ color: '#ffffff' }, { visibility: 'on' }, { weight: 2 }],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry',
		stylers: [{ color: '#FAF7F6' }, { visibility: 'off' }],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry',
		stylers: [{ color: '#FAF7F6' }],
	},
	{
		featureType: 'poi',
		elementType: 'geometry',
		stylers: [{ color: '#f2dfd0' }, { visibility: 'off' }],
	},
	{
		featureType: 'road',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#b29286' }, { weight: 0.5 }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.fill',
		stylers: [{ color: '#c8aaa5' }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#ebe6e4' }],
	},
	{
		featureType: 'road.local',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#ab8c7d' }],
	},
	{
		featureType: 'transit',
		elementType: 'geometry',
		stylers: [{ color: '#ebe6e4' }, { visibility: 'off' }],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [{ color: '#ebe6e4' }],
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }],
	},
];
